import StatusToast from './StatusToast'
import Toast from './Toast'
import ToastBody from './ToastBody'
import ToastBold from './ToastBold'
import ToastHeader from './ToastHeader'

export { StatusToast, ToastBody, ToastBold, ToastHeader }
export default Toast
